import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrxservicesCardPage } from './trxservices-card.page';

const routes: Routes = [
  {
    path: '',
    component: TrxservicesCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrxservicesCardPageRoutingModule {}
